import { render, staticRenderFns } from "./InfoPage.vue?vue&type=template&id=36786eb1&scoped=true"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"
import style0 from "./InfoPage.vue?vue&type=style&index=0&id=36786eb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36786eb1",
  null
  
)

export default component.exports